import Loadable from "react-loadable";
import LoadingComponent from "../../commons/loader";

export default [
  {
    path: "/dashboard/resources",
    exact: true,
    authL: true,
    component: Loadable({
      loader: () => import("./pages/knowledge"),
      loading: LoadingComponent
    })
  },
  {
    path: "/dashboard/resources/promo",
    exact: true,
    authL: true,
    component: Loadable({
      loader: () => import("./pages/promo"),
      loading: LoadingComponent
    })
  }
];
